import { render, staticRenderFns } from "./storeSetting.vue?vue&type=template&id=3be09282&"
import script from "./storeSetting.vue?vue&type=script&lang=js&"
export * from "./storeSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports